/**
 * Helper for reading the status off a value caught from an RTK Query
 * `.unwrap()` rejection.
 *
 * `.unwrap()` rejects with `FetchBaseQueryError | SerializedError`, so `status`
 * only exists on the former. Rather than asserting a shape that is not always
 * there, this narrows `unknown` by checking for the property before reading it
 * — which keeps the previous optional-chaining semantics (`undefined` for
 * anything else) exactly.
 */

const isRecord = (error: unknown): error is Record<string, unknown> => {
  return typeof error === "object" && error !== null;
};

/**
 * The HTTP status of a `FetchBaseQueryError`, or `undefined` for any other
 * rejection value. Non-HTTP RTK errors carry a string status
 * ("FETCH_ERROR" | "PARSING_ERROR" | ...), which is preserved as-is.
 */
export const getErrorStatus = (error: unknown): number | string | undefined => {
  if (!isRecord(error)) {
    return undefined;
  }

  const { status } = error;
  if (typeof status === "number" || typeof status === "string") {
    return status;
  }

  return undefined;
};
